import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-subject-modal',
  templateUrl: './subject-modal.component.html',
  styleUrls: ['./subject-modal.component.scss']
})
export class SubjectModalComponent implements OnInit {

  form: UntypedFormGroup

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder
    )
  {
    this.form = this.fb.group({
      id: [null, [Validators.required]],
      totAdministeredCondominiums: [0, [Validators.required]],
    })

    if(data){
      if(data?.subject) this.form.get('id')?.setValue(`${data?.subject.id}`)
      if(data?.subject?.totAdministeredCondominiums) this.form.get('totAdministeredCondominiums')?.setValue(`${data?.subject?.totAdministeredCondominiums}`)
    }


  }

  ngOnInit(): void {
  }

  clearSubject(){
    console.log('clearSubject')
    this.form?.get('id')?.setValue(null)
    this.form?.get('totAdministeredCondominiums')?.setValue(0)
  }

  selSubject(event: any) {
    console.log('Selected: ', event);
    if(event?.id){
      this.form?.get('subjectToId')?.setValue(event.id)
    } 
  }

  requiresApproval(subjectRelationType: any){
    let requiresApprovalString = ``
    if(subjectRelationType.requiresApproval) requiresApprovalString = 'SUBJECT_RELATION_TYPES.requiresApproval'
    return requiresApprovalString
  }

}
